export enum CommentType {
  Notepad = 1,
  Survey = 2,
  Project = 3,
  Poll = 4,
  MarketCategory = 5
}
